import React from 'react';

function Crop({ fill = '#1D1C1D', width = 20, height = 20, ...rest }) {
  return (
    <svg width={width} height={height} {...rest} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_12_8234)">
        <path d="M14.4793 19.1666V15.7291H5.521C5.18766 15.7291 4.896 15.6041 4.646 15.3541C4.396 15.1041 4.271 14.8125 4.271 14.4791V5.52081H0.833496V4.27081H4.271V0.833313H5.521V14.4791H19.1668V15.7291H15.7293V19.1666H14.4793ZM14.4793 13.2291V5.52081H6.771V4.27081H14.4793C14.8127 4.27081 15.1043 4.39581 15.3543 4.64581C15.6043 4.89581 15.7293 5.18748 15.7293 5.52081V13.2291H14.4793Z" fill={fill} />
      </g>
      <defs>
        <clipPath id="clip0_12_8234">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>

  );
}

export default Crop;
